import en from '@/translations/i18n/en';
import it from '@/translations/i18n/it';

export default {
  en: {
    all: en,
  },
  it: {
    all: it,
  },
};
